import {
  GET_LIST_ACCOUNT_TRANSACTION,
  GET_LIST_ACCOUNT_TRANSACTION_SUCCESS,
  GET_LIST_ACCOUNT_TRANSACTION_FAIL,
  GET_ACCOUNT_TRANSACTION,
  GET_ACCOUNT_TRANSACTION_SUCCESS,
  GET_ACCOUNT_TRANSACTION_FAIL,
  ADD_ACCOUNT_TRANSACTION,
  ADD_ACCOUNT_TRANSACTION_SUCCESS,
  ADD_ACCOUNT_TRANSACTION_FAIL,
  DELETE_ACCOUNT_TRANSACTION,
  DELETE_ACCOUNT_TRANSACTION_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_FAIL,
  CLEAR_LIST_ACCOUNT_TRANSACTION,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL,
  EXPORT_EXCEL_ACCOUNT_TRANSACTION,
  EXPORT_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  EXPORT_EXCEL_ACCOUNT_TRANSACTION_FAIL,
  UPDATE_ACCOUNT_TRANSACTION,
  UPDATE_ACCOUNT_TRANSACTION_SUCCESS,
  UPDATE_ACCOUNT_TRANSACTION_FAIL,
  ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION,
  ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL,
  GET_LIST_ACCOUNT_TRANSACTION_DRAFT,
  GET_LIST_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  GET_LIST_ACCOUNT_TRANSACTION_DRAFT_FAIL,
  CLEAR_LIST_ACCOUNT_TRANSACTION_DRAFT,
  UPDATE_ACCOUNT_TRANSACTION_DRAFT,
  UPDATE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  UPDATE_ACCOUNT_TRANSACTION_DRAFT_FAIL,
  DELETE_ACCOUNT_TRANSACTION_DRAFT,
  DELETE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_DRAFT_FAIL,
  UPDATE_ACCOUNT_TRANSACTION_CHECK,
  UPDATE_ACCOUNT_TRANSACTION_CHECK_ALL,
  DELETE_ACCOUNT_TRANSACTION_BULK,
  DELETE_ACCOUNT_TRANSACTION_BULK_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_BULK_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  listAccountTransaction: [],
  listAccountTransactionDraft: [],
  accountTransaction: null,
  error: '',
  loading: false,
  loadingDraft: false,
  loadingSaveDraft: false,
  loadingDeleteDraft: false,
};

const AccountTransaction = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LIST_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        listAccountTransaction: action.payload,
        loading: false,
      };
    case GET_LIST_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case GET_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case GET_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        accountTransaction: action.payload,
        loading: false,
      };
    case GET_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };


    case ADD_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case ADD_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case UPDATE_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };


    case DELETE_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CLEAR_LIST_ACCOUNT_TRANSACTION:
      return {
        ...state,
        listAccountTransaction: [],
        loading: false,
      };

    case ADD_BY_EXCEL_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case ADD_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case EXPORT_EXCEL_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case EXPORT_EXCEL_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case EXPORT_EXCEL_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case GET_LIST_ACCOUNT_TRANSACTION_DRAFT:
      return {
        ...state,
        loadingDraft: true,
      };
    case GET_LIST_ACCOUNT_TRANSACTION_DRAFT_SUCCESS:
      return {
        ...state,
        listAccountTransactionDraft: action.payload,
        loadingDraft: false,
      };
    case GET_LIST_ACCOUNT_TRANSACTION_DRAFT_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingDraft: false,
      };

    case CLEAR_LIST_ACCOUNT_TRANSACTION_DRAFT:
      return {
        ...state,
        listAccountTransactionDraft: [],
        loading: false,
      };

    case UPDATE_ACCOUNT_TRANSACTION_DRAFT:
      return {
        ...state,
        loadingSaveDraft: true,
      };
    case UPDATE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS:
      return {
        ...state,
        loadingSaveDraft: false,
      };
    case UPDATE_ACCOUNT_TRANSACTION_DRAFT_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingSaveDraft: false,
      };

    case DELETE_ACCOUNT_TRANSACTION_DRAFT:
      return {
        ...state,
        loadingDeleteDraft: true,
      };
    case DELETE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS:
      return {
        ...state,
        loadingDeleteDraft: false,
      };
    case DELETE_ACCOUNT_TRANSACTION_DRAFT_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingDeleteDraft: false,
      };

    case UPDATE_ACCOUNT_TRANSACTION_CHECK:
      const { idx } = action.payload;
      const updatedData = [...state.listAccountTransaction];
      updatedData[idx.idx].checked = !updatedData[idx.idx].checked;
      return {
        ...state,
        listAccountTransaction: updatedData
      };

    case UPDATE_ACCOUNT_TRANSACTION_CHECK_ALL:
      const { data } = action.payload;
      const updatedNewData = [...state.listAccountTransaction];
      updatedNewData.map(item => {
        return {
          ...item,
          checked: data.data
        };
      });
      return {
        ...state,
        listAccountTransaction: updatedNewData.map(item => {
          return {
            ...item,
            checked: data.data
          };
        })
      };

    case DELETE_ACCOUNT_TRANSACTION_BULK:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ACCOUNT_TRANSACTION_BULK_SUCCESS:
      return {
        ...state,
        listAccountTransaction: [],
        loading: true,
      };
    case DELETE_ACCOUNT_TRANSACTION_BULK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default AccountTransaction;
